/**
 * 下拉菜单
 */
import { fontVariables } from '@hzero-front-ui/font';
import dropdownStyle from "../templates/Dropdown.style";
import dropdownBaseStyle from "../templates/DropDowBase.style";
import dropDownHzeroStyle from "../templates-hzero/DropDown.style";
var defaultIconfontFamily = fontVariables.defaultIconfontFamily;
var dropdownData = {
  name: 'dropdown',
  data: [{
    fontSize: 12,
    fontColor: '#0F1358',
    iconfontFamily: defaultIconfontFamily,
    activeFontColor: '#0840F8',
    iconCheckIconContent: '\\E5CA',
    itemHeight: 28,
    minWidth: 114,
    iconMarginRight: -1,
    popupRootPadding: '0.06rem 0.08rem'
  }],
  onlyTemplate: {
    pro: dropdownStyle,
    base: dropdownBaseStyle,
    hzero: dropDownHzeroStyle
  }
};
export default dropdownData;